export const environment = {
  production: false,

  env: 'dev',

  auth: {
    region: 'eu-west-1',
    clientId: '5ip83l264l5pvsie5ng0jdeu6e',
    poolId: 'eu-west-1_UVh5hA4H9'
  },
  oauth: {
    domain: 'auth2.dev.quizwin.pro',
    redirectSignIn: 'https://dev.quizwin.pro/sign-in',
    redirectSignOut: 'https://dev.quizwin.pro/sign-in'
  },
  api: {
    host: 'https://api.dev.quizwin.pro'
  },
  ui: {
    host: 'dev.quizwin.pro'
  },
  landing: {
    host: 'https://www.quizwin.pro',
    urls: {
      organize: '/organize',
    }
  },

  editor: {
    tinyApiKey: 'er3v4zp6jhdkofjgdspevn0hzr6q8bu78r2v80w71829no9e'
  },

  contacts: {
    supportEmail: 'support@quizwin.pro'
  },

  track: {
    analyticsId: 'G-8PM00RH230'
  },

  sentry: {
    enabled: true,
    dns: 'https://d35f428e24d0472a961f27fd36aed2fd@o1072753.ingest.sentry.io/6071989',
    sample_rate: 0.2
  },

  smartlook: {
    enabled: false,
  }
};
